import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks';
import { isPaymentRoute } from '../../config/paymentRoutes';
import loadRazorpayScript from '../../utils/loadRazorpayScript';

const RazorpayScriptLoader = () => {
    const { pathname } = useLocation();
    const { isAuthenticated } = useAuth();

    useEffect(() => {
        if (!isAuthenticated || !isPaymentRoute(pathname)) {
            return;
        }

        loadRazorpayScript().catch((error) => {
            console.warn('Failed to preload Razorpay checkout:', error);
        });
    }, [isAuthenticated, pathname]);

    return null;
};

export default RazorpayScriptLoader;
